import config from 'config'
import { createLogic } from 'redux-logic'
import { fetchAction, getDateForRequest } from 'utils'

import { ACTIVE_CLOSED_TAB, DELAYED_RTLOG_TAB, ZERO_REPORTING_TAB } from '../components/Completeness/constants'
import {
  FETCH_COMPLETENESS_GENERAL_REVENUE,
  FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR,
  FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS,
  FETCH_DELAYED_STORES,
  FETCH_DELAYED_STORES_ERROR,
  FETCH_DELAYED_STORES_SUCCESS,
} from './constants'

const getParamsForTab = tab => {
  switch (tab) {
    case ZERO_REPORTING_TAB:
      return {
        zeroReportingOnly: true,
      }

    case ACTIVE_CLOSED_TAB:
      return {
        activeClosedOnly: true,
      }

    case DELAYED_RTLOG_TAB:
      return {
        resaDelayedOnly: true,
      }

    default:
      return {
        delayedOnly: true,
      }
  }
}

const fetchCompletenessGeneralRevenue = createLogic({
  type: FETCH_COMPLETENESS_GENERAL_REVENUE,
  latest: true,

  process({ getState }, dispatch, done) {
    const state = getState()
    const { dateCurrent } = state.datePicker

    fetchAction(config.api.group, {
      dateCurrent: getDateForRequest(dateCurrent),
    })
      .then(response => dispatch({ type: FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS, data: response.data }))
      .catch(() => dispatch({ type: FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR }))
      .then(() => done())
  },
})

const fetchDelayedStores = createLogic({
  type: FETCH_DELAYED_STORES,
  latest: true,

  process({ getState }, dispatch, done) {
    const state = getState()
    const { dateCurrent } = state.datePicker
    const { selectedValue } = state.componentsCompleteness

    fetchAction(config.api.stores, {
      dateCurrent: getDateForRequest(dateCurrent),
      ...getParamsForTab(selectedValue),
      ecoms: true,
      necoms: true,
    })
      .then(response => dispatch({ type: FETCH_DELAYED_STORES_SUCCESS, data: response.data }))
      .catch(() => dispatch({ type: FETCH_DELAYED_STORES_ERROR }))
      .then(() => done())
  },
})

export default [fetchCompletenessGeneralRevenue, fetchDelayedStores]
